// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[6].use[1]!../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[6].use[2]!../../breakpoints.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.legal-structures_table__XOvgz {
    display: grid;
    grid-template-columns: 240px auto 240px;
    /*grid-gap: 53px;*/
    margin: 18px auto 0;
    width: var(--container-width);
    max-width: 100%;
    padding: 0 var(--container-padding);
}

.legal-structures_mainStructuresWrapper__RWEWx {
    display: flex;
    height: 100%;
    flex: 1 1;
}

.legal-structures_leftResults__9IcvM {
    width: 400px;
    padding: 50px;
}

.legal-structures_card__aTSGn {
    padding: 10px;
    border: 1px solid gray;
    margin-bottom: 20px;
}

.legal-structures_disabledLink__kWgDM {
    pointer-events: none;
    background-color: var(--light-grey) !important;
    border-color: var(--light-grey) !important;
}

.legal-structures_selectSection__bvL7w {
    width: 700px;
    min-width: 700px;
    padding: 50px;
    display: flex;
    flex: 0 1;
    flex-direction: column;
    margin: 0 auto;
}

.legal-structures_detailsSection__-fAfG {
    width: 700px;
    padding: 50px;
}

.legal-structures_structureBar__E-6YT {
    margin: 200px 0;
    display: flex;
    flex-wrap: wrap;
}

.legal-structures_optionLabel__AbjQj {
    background: var(--light-yellow);
    padding: 10px;
    width: 150px;
    border: 1px solid black;
    cursor: pointer;
}

.legal-structures_option__7bBfR {
    display: none;
}

.legal-structures_option__7bBfR:checked + .legal-structures_optionLabel__AbjQj {
    border: 1px solid yellow;
}

.legal-structures_gridOptions__O0xkN {
    display: grid;
    grid-template-columns: repeat(3, 200px);
}

.legal-structures_gridCard__5DWpw {
    border: 1px solid gray;
    padding: 10px;
}

.legal-structures_selectedCard__wyNNQ {
    border: 2px solid var(--dark-blue);
}

.legal-structures_compare__-SzVL {
    background: var(--light-yellow);
    padding: 10px;
    color: var(--dark-blue);
    position: fixed;
    z-index: 20;
    bottom: 40px;
    right: 40px;
    border: 1px solid black;
}

.legal-structures_graph__80zkZ {
    text-align: center;
    /*padding: 10px 0;*/
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    row-gap: 20px;
    min-height: 100%;
}

.legal-structures_graph__80zkZ > div {
    flex: 1 1;
    width: 100%;

    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
}

.legal-structures_graph__80zkZ svg {
    max-width: 100%;
    width: 100%;
    height: auto;
    /*height: 100%;*/
    /*width: auto;*/
    margin: auto auto 0;
    max-height: calc(100vh - var(--header-height) - 140px);
}

.legal-structures_actions__c7-Jq {
    display: flex;
    justify-content: center;
    column-gap: 169px;
    row-gap: 16px;
    flex-wrap: wrap;
    margin-top: auto;
}

.legal-structures_btn__FtkHM {
    color: #fff;
    border: 1px solid var(--primary-color);
    background: var(--primary-color);
    border-radius: 22px;
    font-size: 16px;
    cursor: pointer;
    padding: 10px 10px;
    transition:
        background-color 0.4s,
        border-color 0.4s;
    width: 170px;
    height: 44px;
    margin: auto auto 0;
    display: inline-flex;
    align-items: center;
    justify-content: center;
}

.legal-structures_btn__FtkHM:hover {
    color: #fff;
    background-color: var(--primary-color-active);
    border-color: var(--primary-color-active);
}

.legal-structures_info__v8zwI {
    white-space: nowrap;
    font-size: 24px;
    font-weight: 400;
}

.legal-structures_highlight__jmlTb {
    color: var(--primary-color);
    font-weight: 700;
}

@media ${___CSS_LOADER_ICSS_IMPORT_0___.locals["screen-md-max"]} {
    .legal-structures_actions__c7-Jq {
        column-gap: 80px;
    }
}
`, "",{"version":3,"sources":["webpack://./src/pages/LegalStructures/legal-structures.module.css"],"names":[],"mappings":"AAEA;IACI,aAAa;IACb,uCAAuC;IACvC,kBAAkB;IAClB,mBAAmB;IACnB,6BAA6B;IAC7B,eAAe;IACf,mCAAmC;AACvC;;AAEA;IACI,aAAa;IACb,YAAY;IACZ,SAAO;AACX;;AAEA;IACI,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,oBAAoB;IACpB,8CAA8C;IAC9C,0CAA0C;AAC9C;;AAEA;IACI,YAAY;IACZ,gBAAgB;IAChB,aAAa;IACb,aAAa;IACb,SAAS;IACT,sBAAsB;IACtB,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,eAAe;IACf,aAAa;IACb,eAAe;AACnB;;AAEA;IACI,+BAA+B;IAC/B,aAAa;IACb,YAAY;IACZ,uBAAuB;IACvB,eAAe;AACnB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,aAAa;IACb,uCAAuC;AAC3C;;AAEA;IACI,sBAAsB;IACtB,aAAa;AACjB;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,+BAA+B;IAC/B,aAAa;IACb,uBAAuB;IACvB,eAAe;IACf,WAAW;IACX,YAAY;IACZ,WAAW;IACX,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,sBAAsB;IACtB,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,SAAO;IACP,WAAW;;IAEX,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,mBAAmB;IACnB,sDAAsD;AAC1D;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,iBAAiB;IACjB,aAAa;IACb,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,sCAAsC;IACtC,gCAAgC;IAChC,mBAAmB;IACnB,eAAe;IACf,eAAe;IACf,kBAAkB;IAClB;;yBAEqB;IACrB,YAAY;IACZ,YAAY;IACZ,mBAAmB;IACnB,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,WAAW;IACX,6CAA6C;IAC7C,yCAAyC;AAC7C;;AAEA;IACI,mBAAmB;IACnB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;IAC3B,gBAAgB;AACpB;;AAEA;IACI;QACI,gBAAgB;IACpB;AACJ","sourcesContent":["@value screen-md-max from '../../breakpoints.css';\n\n.table {\n    display: grid;\n    grid-template-columns: 240px auto 240px;\n    /*grid-gap: 53px;*/\n    margin: 18px auto 0;\n    width: var(--container-width);\n    max-width: 100%;\n    padding: 0 var(--container-padding);\n}\n\n.mainStructuresWrapper {\n    display: flex;\n    height: 100%;\n    flex: 1;\n}\n\n.leftResults {\n    width: 400px;\n    padding: 50px;\n}\n\n.card {\n    padding: 10px;\n    border: 1px solid gray;\n    margin-bottom: 20px;\n}\n\n.disabledLink {\n    pointer-events: none;\n    background-color: var(--light-grey) !important;\n    border-color: var(--light-grey) !important;\n}\n\n.selectSection {\n    width: 700px;\n    min-width: 700px;\n    padding: 50px;\n    display: flex;\n    flex: 0 1;\n    flex-direction: column;\n    margin: 0 auto;\n}\n\n.detailsSection {\n    width: 700px;\n    padding: 50px;\n}\n\n.structureBar {\n    margin: 200px 0;\n    display: flex;\n    flex-wrap: wrap;\n}\n\n.optionLabel {\n    background: var(--light-yellow);\n    padding: 10px;\n    width: 150px;\n    border: 1px solid black;\n    cursor: pointer;\n}\n\n.option {\n    display: none;\n}\n\n.option:checked + .optionLabel {\n    border: 1px solid yellow;\n}\n\n.gridOptions {\n    display: grid;\n    grid-template-columns: repeat(3, 200px);\n}\n\n.gridCard {\n    border: 1px solid gray;\n    padding: 10px;\n}\n\n.selectedCard {\n    border: 2px solid var(--dark-blue);\n}\n\n.compare {\n    background: var(--light-yellow);\n    padding: 10px;\n    color: var(--dark-blue);\n    position: fixed;\n    z-index: 20;\n    bottom: 40px;\n    right: 40px;\n    border: 1px solid black;\n}\n\n.graph {\n    text-align: center;\n    /*padding: 10px 0;*/\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-direction: column;\n    row-gap: 20px;\n    min-height: 100%;\n}\n\n.graph > div {\n    flex: 1;\n    width: 100%;\n\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-direction: column;\n}\n\n.graph svg {\n    max-width: 100%;\n    width: 100%;\n    height: auto;\n    /*height: 100%;*/\n    /*width: auto;*/\n    margin: auto auto 0;\n    max-height: calc(100vh - var(--header-height) - 140px);\n}\n\n.actions {\n    display: flex;\n    justify-content: center;\n    column-gap: 169px;\n    row-gap: 16px;\n    flex-wrap: wrap;\n    margin-top: auto;\n}\n\n.btn {\n    color: #fff;\n    border: 1px solid var(--primary-color);\n    background: var(--primary-color);\n    border-radius: 22px;\n    font-size: 16px;\n    cursor: pointer;\n    padding: 10px 10px;\n    transition:\n        background-color 0.4s,\n        border-color 0.4s;\n    width: 170px;\n    height: 44px;\n    margin: auto auto 0;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.btn:hover {\n    color: #fff;\n    background-color: var(--primary-color-active);\n    border-color: var(--primary-color-active);\n}\n\n.info {\n    white-space: nowrap;\n    font-size: 24px;\n    font-weight: 400;\n}\n\n.highlight {\n    color: var(--primary-color);\n    font-weight: 700;\n}\n\n@media screen-md-max {\n    .actions {\n        column-gap: 80px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"screen-md-max": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["screen-md-max"]}`,
	"table": `legal-structures_table__XOvgz`,
	"mainStructuresWrapper": `legal-structures_mainStructuresWrapper__RWEWx`,
	"leftResults": `legal-structures_leftResults__9IcvM`,
	"card": `legal-structures_card__aTSGn`,
	"disabledLink": `legal-structures_disabledLink__kWgDM`,
	"selectSection": `legal-structures_selectSection__bvL7w`,
	"detailsSection": `legal-structures_detailsSection__-fAfG`,
	"structureBar": `legal-structures_structureBar__E-6YT`,
	"optionLabel": `legal-structures_optionLabel__AbjQj`,
	"option": `legal-structures_option__7bBfR`,
	"gridOptions": `legal-structures_gridOptions__O0xkN`,
	"gridCard": `legal-structures_gridCard__5DWpw`,
	"selectedCard": `legal-structures_selectedCard__wyNNQ`,
	"compare": `legal-structures_compare__-SzVL`,
	"graph": `legal-structures_graph__80zkZ`,
	"actions": `legal-structures_actions__c7-Jq`,
	"btn": `legal-structures_btn__FtkHM`,
	"info": `legal-structures_info__v8zwI`,
	"highlight": `legal-structures_highlight__jmlTb`
};
export default ___CSS_LOADER_EXPORT___;
